var map = {
	"./Logo_97x23.png": "5c83",
	"./avatarfloor.png": "c4bc",
	"./communication2.png": "90ef",
	"./communnicate.png": "7cc8",
	"./hr1.png": "83d3",
	"./intro_background.png": "9043",
	"./logo_sm.png": "8105",
	"./myoffice1.png": "9d7f",
	"./myoffice2.png": "69e4",
	"./myschedule1.png": "016c",
	"./myschedule2.png": "a35a",
	"./robothead.jpg": "e7f7",
	"./robothead.png": "e541",
	"./student.png": "f070",
	"./teacher.png": "47d1",
	"./topbar1.png": "0a17",
	"./topbar2.png": "a1ae",
	"./topbar3.png": "303d",
	"./wholeclass.png": "da95"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";